@import ../../styles/helpers

.hide
    display: none !important

.container
    width: 100%
    height: 100%
    &:not(.simple)
        display: flex
        width: 100vw
        max-width: 1440px
        height: calc(100vh - $header_height )
        position: absolute
        left: 50vw
        transform: translateX(-50%)
        background-color: $page_background
        z-index: 1
        &:has(>div.active)
            z-index: 2
        +m
            height: 100%
            padding-top: 2px
    +m
        top: 0

    .column_messages
        max-width: 360px
        width: 100%
        height: 100%
        overflow: hidden
        overflow-y: auto
        padding-bottom: calc( $header_height / 2 + $external_margin )
        border-top: 1px solid $bordercolor
        border-right: 1px solid $bordercolor
        padding: 10px
        +m
            max-width: none
        &::-webkit-scrollbar
            display: none
        

    .column_chat
        flex-grow: 1
        display: flex
        align-items: center
        flex-direction: column
        position: relative
        padding: 16px
        padding-top: 0
        padding-bottom: 12px
        border-top: 1px solid $bordercolor
        +m
            width: 100vw
            position: absolute
            top: 0
            height: calc(100vh - $header_height)
            left: 0
            background-color: #11141B
            z-index: 3
            display: none
            padding-bottom: 0px
            &.active
                display: block
                transform: translateY(-70px)
                height: calc(100% + 70px)
                padding: 0

    &.simple
        .column_chat
            display: none
            pointer-events: none
        .column_messages
            transform: none
